<template>
  <div class="row mt-1 m-0 mb-0 pb-0">
    <div class="table-responsive mx-0 px-1 mb-0 pb-0">
      <div v-for="event in events">
        <table id="result-tbl" class="table align-middle table-sm table-bordered table-hover mt-2 mb-1">
          <thead>
              <tr>
                <th scope="col" class="event-id-column" colspan="2" nowrap>{{ event.event_id }}</th>
              </tr>
          </thead>
          <tbody>
            <template v-if="user && user.email">
              <tr v-for="entry in getEntries(event.event_id)" data-bs-toggle="modal" data-bs-target="#editEntryModal" @click="openEditEntryForm(event.event_id, entry.entry_id)">
                <td class="team-column"><TeamLabelComponent :teamId="entry.team_id_1"/></td>
                <td class="player-column">
                  <table><tr>
                    <td><img src="/avator/avator-man-1-2-48.png" width="24" height="24"></td><td style="max-width: 130px">{{ entry.player_name_1 }}</td>
                    <template v-if="entry.player_name_2 != ''"><td><span v-if="entry.team_id_1 != entry.team_id_2"><TeamLabelComponent :teamId="entry.team_id_2"/></span><img src="/avator/avator-woman-48.png" width="24" height="24"></td><td>{{ entry.player_name_2 }}</td></template>
                  </tr></table>
                </td>
              </tr>
            </template>
            <template v-if="!user || !user.email">
              <tr v-for="entry in getEntries(event.event_id)" >
                <td class="team-column"><TeamLabelComponent :teamId="entry.team_id_1"/></td>
                <td class="player-column">
                  <table><tr>
                    <td><img src="/avator/avator-man-1-2-48.png" width="24" height="24"></td><td style="max-width: 130px">{{ entry.player_name_1 }}</td>
                    <template v-if="entry.player_name_2 != ''"><td><span v-if="entry.team_id_1 != entry.team_id_2"><TeamLabelComponent :teamId="entry.team_id_2"/></span><img src="/avator/avator-woman-48.png" width="24" height="24"></td><td>{{ entry.player_name_2 }}</td></template>
                  </tr></table>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

    </div>
  </div>

  <AffiliateComponent />
  <hr>
  <span style="display: flex;justify-content: center; font-size: 10pt; color:darkgrey">Avator icons provided by&nbsp; <a target="_blank" href="https://icons8.com">Icons8</a></span>

  <!-- fab -->
  <div class="fab-container">
    <div class="btn-group btn-group-lg buttons" role="group" aria-label="radio toggle button group">
      <input type="radio" class="btn-check" name="vbtn-radio" id="vbtn-radio1" autocomplete="off" @click="showRankByGrade(6)" :checked="6 == rank_event_id" onclick="gtag('event', 'app-show-rank-grade-6', {'event_category': 'button','event_label': 'app-show-rank-grade-6'});">
      <label class="btn btn-outline-primary" for="vbtn-radio1">6</label>
      <input type="radio" class="btn-check" name="vbtn-radio" id="vbtn-radio2" autocomplete="off" @click="showRankByGrade(5)" :checked="5 == rank_event_id" onclick="gtag('event', 'app-show-rank-grade-5', {'event_category': 'button','event_label': 'app-show-rank-grade-5'});">
      <label class="btn btn-outline-primary" for="vbtn-radio2">5</label>
      <input type="radio" class="btn-check" name="vbtn-radio" id="vbtn-radio3" autocomplete="off" @click="showRankByGrade(4)" :checked="4 == rank_event_id" onclick="gtag('event', 'app-show-rank-grade-4', {'event_category': 'button','event_label': 'app-show-rank-grade-4'});">
      <label class="btn btn-outline-primary" for="vbtn-radio3">4</label>
      <input type="radio" class="btn-check" name="vbtn-radio" id="vbtn-radio4" autocomplete="off" @click="showRankByGrade(3)" :checked="3 == rank_event_id" onclick="gtag('event', 'app-show-rank-grade-3', {'event_category': 'button','event_label': 'app-show-rank-grade-3'});">
      <label class="btn btn-outline-primary" for="vbtn-radio4">3</label>
      <input type="radio" class="btn-check" name="vbtn-radio" id="vbtn-radio5" autocomplete="off" @click="showRankByGrade(2)" :checked="2 == rank_event_id" onclick="gtag('event', 'app-show-rank-grade-2', {'event_category': 'button','event_label': 'app-show-rank-grade-2'});">
      <label class="btn btn-outline-primary" for="vbtn-radio5">2</label>
    </div>
  </div>

  <div class="text-center" v-if="isLoading">
    <div class="spinner-border spinner" role="status">
        <span class="sr-only">Loading...</span>
    </div>
  </div>

  <EditEntryFormComponent :selectedEntryId="selectedEntryId" :selectedEntry="selectedEntry" @doReload="doReload"></EditEntryFormComponent>
  <FooterComponent @reloadRank="reloadRank"></FooterComponent>
</template>
  
<script setup>
import EditEntryFormComponent from '@/components/EditEntryFormComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'
import AffiliateComponent from '@/components/AffiliateComponent.vue'
import TeamLabelComponent from '@/components/TeamLabelComponent.vue'
import { ref, onMounted, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ref as fbRef, getDatabase, child, get } from "firebase/database"
import { getAuth } from "firebase/auth";
const auth = getAuth();
const user = auth.currentUser;
// const role = ref();
const route = useRoute()
const db = getDatabase();
const dbRef = fbRef(db);
const isLoading = ref()
const entries = ref([])
const events = ref([])
const rank_event_id = ref();

const selectedEventId = ref();
const selectedEventEntries = ref([]);

const selectedMatchKey = ref()
const selectedMatch = ref([]);

const selectedEntryId = ref();
const selectedEntry = ref([]);

onMounted(() => {
  // user.getIdTokenResult()
  // .then((idTokenResult) => {
  //   role.value = idTokenResult.claims.role;
  // })
  rank_event_id.value = localStorage.getItem("rank_event_id");
  // console.log(rank_event_id)
  // console.log(rank_event_id.value)
  if (rank_event_id.value == null || rank_event_id.value == "") {
    rank_event_id.value = "6";
  }
  events.value = getEventsByGrade(rank_event_id.value);
  localStorage.setItem("rank_event_id", rank_event_id.value);
});

const doReload = () => {
  const event_id = localStorage.getItem("rank_event_id");
  showRankByGrade(event_id)
}

const reloadRank = async () => {
  isLoading.value = true;
  await fetchEntries();
  const event_id = localStorage.getItem("rank_event_id");
  showRankByGrade(event_id)
  isLoading.value = false;
}

const showRankByGrade = (event_id) => {
  events.value = getEventsByGrade(event_id);
  localStorage.setItem("rank_event_id", event_id);
}

const fetchEntries = async () => {
    await get(child(dbRef, '/2026-summer/entries')).then((snapshot) => {
        if (snapshot.exists()) {
            localStorage.setItem('entries', JSON.stringify(snapshot.val()));
        } else {
            console.log('No entry data')
        }
    }).catch((error) => {
        console.error(error)
    })
};


const getEventsByGrade = (event_id) => {
  const allEvents = ref([]);
  allEvents.value = JSON.parse(localStorage.getItem("events"));
  if (!allEvents.value) { return; }
  const eventRegex = new RegExp(event_id, "i");
  return Object.fromEntries(
    Object.entries(allEvents.value).filter(([key, value]) =>
      (eventRegex.test(value.event_id.toLowerCase())))
      .sort(function (a, b) {
        if (a[1].method < b[1].method) { return 1 }
        if (a[1].method > b[1].method) { return -1 }
        if (a[0] < b[0]) { return -1 }
        if (a[0] > b[0]) { return 1 }
        return 0
      })
  );
}

const getEntries = (event_id) => {
  if (!event_id) { return; }
  const allEntries = ref([]);
  allEntries.value = JSON.parse(localStorage.getItem("entries"));
  return Object.fromEntries(
    Object.entries(allEntries.value).filter(([key, value]) =>
      (event_id == value.event_id)).sort(function (a, b) {
        // if (a[1].rank < b[1].rank) { return -1 }
        // if (a[1].rank > b[1].rank) { return 1 }
        if (a[0] < b[0]) { return -1 }
        if (a[0] > b[0]) { return 1 }
        return 0
      })
  );
};

const openEditEntryForm = (event_id, entry_id) => {
  selectedEntryId.value = event_id + "-" + entry_id;
  get(child(dbRef, '/2026-summer/entries/' + event_id + "-" + entry_id))
    .then((snapshot) => {
        if (snapshot.exists()) {
          selectedEntry.value = snapshot.val();
        } else {
          console.warn("Not found - entry:" + event_id + "-" + entry_id)
        }
    });
}

</script>
  
<style scoped>
#result-tbl {
  border-color: #dee2e6;
}

.rank-column {
  width: 25px;
}

th.rank-column {
  background-color: #e9ecef;
}

.event-id-column {
  background-color: #a3cfbb;
  text-align: center;
}

th.point-clmn {
  background-color: #e9ecef;
}

.team-column {
  border-right: none;
  width: 50px;
}

.player-column {
  text-align: left;
  border-left: none;
}

tr.boundary {
  border-top: 2px solid #198754;
}

.spinner {
  position: fixed;
  left: 50%;
  top: 20%;
  margin: 0px auto;
  z-index: 999;
}

.fab-container {
  position: fixed;
  bottom: 70px;
  right: 20px;
  /* left: 50%; */
  cursor: pointer;
  z-index: 8;
}

.buttons {
  box-shadow: 5px 5px 5px #aaaaaa;
  background-color: #fff;
}

#vbtn-radio1 {
  background-color: white;
}
</style>